<template>
<div>
              <div>
                <div v-if="editVidName == false">
                <h1>CI for: {{this.$root.globalStore.currentVidTitle}}</h1><b-button type="button" class="btn-small" variant="link" v-on:click="changeVidName">edit name</b-button>

                </div>
                <div v-else>
                <h1>CI for: </h1> <input v-model="vidName">                                 
                <button type="button" class="btn btn-primary" v-on:click="postVidName()">save</button>

                </div>
                <!-- 
                <videoplayer></videoplayer>
                -->

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">cut No</th>
                            <th scope="col">Time</th>
                            <th scope="col">Angle</th>
                            <th scope="col">Source-Time</th>
                            <th scope="col">Special Effects</th>
                            <th scope="col">Memory</th>
                            <th scope="col">Points of Quality</th>
                            <th scope="col">Phase of Lesson</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody v-if="cis">
                        <!-- normale Row -->
                        <tr v-if="schnitt.id != editSchnittId" v-for="(schnitt, index) in schnitte" :key="schnitt.id">
                            <th scope="row">{{schnitt.cutNo}}</th>
                            <td>{{schnitt.vidTime}}</td>
                            <td>{{schnitt.angle}}</td>
                            <td>{{schnitt.sourceTime}}</td>
                            <td>{{schnitt.specialEffects}}</td>
                            <td>{{schnitt.memory}}</td>
                            <td>{{schnitt.pointsOfQuality}}</td>
                            <td>{{schnitt.phaseOfLesson}}</td>
                            <td>
                                <button type="button" class="btn btn-secondary" v-on:click="changeEditId(schnitt.id, index)">edit</button>
                                <b-button type="button" variant="link" sizing="small" v-on:click="deleteSchnitt(schnitt.id)">delete</b-button>
                            </td>
                        </tr>

                        <!-- Row zum bearbeiten -->
                        <tr v-else>
                            <th scope="row">
                                <input v-model="editData.cutNo">
                            </th>
                            <td>
                                <input v-model="editData.vidTime" placeholder="hh:mm:ss">
                            </td>
                            <td>
                                <input v-model="editData.angle">
                            </td>
                            <td>
                                <input v-model="editData.sourceTime" placeholder="hh:mm:ss">
                            </td>
                            <td>
                                <input v-model="editData.specialEffects">
                            </td>
                            <td>
                                <input v-model="editData.memory">
                            </td>
                            <td>
                                <input v-model="editData.pointsOfQuality">
                            </td>
                            <td>
                                <input v-model="editData.phaseOfLesson">
                            </td>
                            <td>
                                <button type="button" class="btn btn-primary" v-on:click="updateSchnitt(editData.id)">save</button>
                            </td>
                        </tr>

                        <!-- Row mit Eingabe -->
                        <tr v-if="showNewRow">
                            <th scope="row">
                                <input v-model="formData.cutNo">
                            </th>
                            <td>
                                <input v-model="formData.vidTime" placeholder="hh:mm:ss">
                            </td>
                            <td>
                                <input v-model="formData.angle">
                            </td>
                            <td>
                                <input v-model="formData.sourceTime" placeholder="hh:mm:ss">
                            </td>
                            <td>
                                <input v-model="formData.specialEffects">
                            </td>
                            <td>
                                <input v-model="formData.memory">
                            </td>
                            <td>
                                <input v-model="formData.pointsOfQuality">
                            </td>
                            <td>
                                <input v-model="formData.phaseOfLesson">
                            </td>
                            <td>
                                <button type="button" class="btn btn-primary" v-on:click="postSchnitt()">save</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button type="button" class="btn btn-success" v-on:click="showNewRow=!showNewRow">Add Row</button>
                <b-button type="button" variant="link" sizing="small" v-on:click="showDeleteAlert=!showDeleteAlert">delete Video</b-button>
                <b-alert show variant="warning" v-if="showDeleteAlert">Do you really want to delte this Video? <b-button variant="danger" v-on:click="deleteVideo()">yes</b-button>  <b-button>No</b-button></b-alert>
            </div>
</div>

</template>

<script>
import video from './videoPlayer.vue';
import {store} from '../store';
import axios from 'axios';
export default {
  name: 'ci-list',
  components: {
      'videoplayer': video,
  },
  data(){
      return{
        showNewRow: false,
        showDeleteAlert: false,
        cis: false,
        editSchnittId: null,
        vidName: '',
        editVidName: false,

        schnitte: [{
          id: '',
          cutNo: '',
          vidTime: '',
          angle: '',
          sourceTime: '',
          specialEffects: '',
          memory: '',
          pointsOfQuality: '',
          phaseOfLesson: '',
        }],
        formData: {
          cutNo: '',
          vidTime: '',
          angle: '',
          sourceTime: '',
          specialEffects: '',
          memory: '',
          pointsOfQuality: '',
          phaseOfLesson: '',
        },
        editData: {
            id: '',
            cutNo: '',
          vidTime: '',
          angle: '',
          sourceTime: '',
          specialEffects: '',
          memory: '',
          pointsOfQuality: '',
          phaseOfLesson: '',
        }
      }
  },

  created(){
    console.log('created');
    this.getSchnitte();
  },

  methods: {
    postSchnitt(){
      let self = this;
      axios({
            method: 'post',
            url: self.$root.globalStore.apiUrl + '/createSchnitt',
            auth: {
                username: self.$root.globalStore.username,
                password: self.$root.globalStore.password,
            },
            data: {
                videoID: self.$root.globalStore.currentVidId,
                cutNo: self.formData.cutNo,
                vidTime: self.formData.vidTime,
                angle: self.formData.angle,
                sourceTime: self.formData.sourceTime,
                specialEffects: self.formData.specialEffects,
                memory: self.formData.memory,
                pointsOfQuality: self.formData.pointsOfQuality,
                phaseOfLesson: self.formData.phaseOfLesson
            }
      }).then(function(response){
          console.log('Schnitt hinzugefügt'),
          self.getSchnitte();
      }).catch(function(error){
          console.log(error);
      });
    },
    deleteSchnitt(schnittId){
                let self = this;
                axios.get(self.$root.globalStore.apiUrl + '/deleteSchnitt/' + schnittId,{
                    auth: {
                        username: self.$root.globalStore.username,
                        password: self.$root.globalStore.password,
                    },
                }).then(function (response) {
                        self.getSchnitte();
                }).catch(function (error) {
                        console.log(error);
                    });
    },
    deleteVideo(){
      let self = this;
      axios.get(self.$root.globalStore.apiUrl + '/deleteVideo/' + self.$root.globalStore.currentVidId, {
            auth: {
                username: self.$root.globalStore.username,
                password: self.$root.globalStore.password,
            }
      }).then(function(response){
        console.log('video gelöscht');
        self.showDeleteAlert = false;
        self.$emit('video-deleted', 'null');
        store.data.currentVidId = null;

      }).catch(function(error){
          if (error.status == 401){
            store.data.wrongPass = false;
            self.$router.push('/')
          } else{
            console.log(error);
          }
      })
    },
    getSchnitte(){
      let self = this;
      axios.get(self.$root.globalStore.apiUrl + '/getSchnitt/'+ self.$root.globalStore.currentVidId,{
            auth: {
                username: self.$root.globalStore.username,
                password: self.$root.globalStore.password,
            }
      })
      .then(function(response) {
        self.schnitte = response.data;
        self.cis = true;
        console.log("Schnitte abgerufen")
      })
      .catch(function(error){
        if(error.response){
          if (error.response.status == 401){
            store.data.wrongPass = false;
            self.$router.push('/')
          }  else if(error.response.status == 404){
              console.log("keine Schnitte für dieses Video")
              } else {
            console.log(error.response);
          }
        }
      })
      },

    changeEditId(id, index){
        this.editSchnittId = id;
        this.editData = this.schnitte[index];
    },
    updateSchnitt(id){
        this.deleteSchnitt(id);
        let self = this;
        axios({
                method: 'post',
                url: self.$root.globalStore.apiUrl + '/createSchnitt',
                auth: {
                    username: self.$root.globalStore.username,
                    password: self.$root.globalStore.password,
                },
                data: {
                    videoID: self.$root.globalStore.currentVidId,
                    cutNo: self.editData.cutNo,
                    vidTime: self.editData.vidTime,
                    angle: self.editData.angle,
                    sourceTime: self.editData.sourceTime,
                    specialEffects: self.editData.specialEffects,
                    memory: self.editData.memory,
                    pointsOfQuality: self.editData.pointsOfQuality,
                    phaseOfLesson: self.editData.phaseOfLesson
                }
        }).then(function(response){
            console.log('Schnitt update durchgeführt'),
            self.editSchnittId = null;
            self.editData = null;
            self.getSchnitte();
            self.editData = {
                    id: '',
                    cutNo: '',
                vidTime: '',
                angle: '',
                sourceTime: '',
                specialEffects: '',
                memory: '',
                pointsOfQuality: '',
                phaseOfLesson: '',
                }
        }).catch(function(error){
            console.log(error);
        });
    },

    changeVidName(){
      this.editVidName = true;
      this.vidName = this.$root.globalStore.currentVidTitle;
    },

    postVidName(){
        let self = this;
      axios({
            method: 'post',
            url: self.$root.globalStore.apiUrl + '/video/changeTitle/' + self.$root.globalStore.currentVidId,
            auth: {
                username: self.$root.globalStore.username,
                password: self.$root.globalStore.password,
            },
            data: {
                vidTitle: this.vidName,
            }
      }).then(function(response){
          console.log('VideoTitle geändert'),
            self.$emit('video-deleted', 'null');
            store.data.currentVidTitle = self.vidName;
            self.editVidName = false;
      }).catch(function(error){
          console.log(error);
      });
    },
    
  },
  

}
</script>



// WEBPACK FOOTER //
// src/components/CI-List.vue